const currentLine = (nodes) =>
  Object.freeze({
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.9,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    nodes: Object.freeze(nodes)
  })

const currentFill = (nodes) =>
  Object.freeze({
    viewBox: '0 0 24 24',
    fill: 'currentColor',
    stroke: 'none',
    nodes: Object.freeze(nodes)
  })

export const icons = Object.freeze({
  dashboard: currentLine([
    { tag: 'rect', attrs: { x: 3, y: 3, width: 8, height: 8, rx: 2 } },
    { tag: 'rect', attrs: { x: 13, y: 3, width: 8, height: 5, rx: 2 } },
    { tag: 'rect', attrs: { x: 3, y: 13, width: 8, height: 8, rx: 2 } },
    { tag: 'path', attrs: { d: 'M14 17H16L17.25 14.5L18.75 19.5L20 17H21' } }
  ]),
  reports: currentLine([
    { tag: 'rect', attrs: { x: 3, y: 3, width: 18, height: 18, rx: 4 } },
    { tag: 'path', attrs: { d: 'M7 16L10.25 12.75L13 14.5L17.5 9' } },
    { tag: 'path', attrs: { d: 'M15 9H17.5V11.5' } }
  ]),
  trade: currentLine([
    { tag: 'path', attrs: { d: 'M4 8H18M18 8L15 5M18 8L15 11' } },
    { tag: 'path', attrs: { d: 'M20 16H6M6 16L9 13M6 16L9 19' } }
  ]),
  orders: currentLine([
    { tag: 'path', attrs: { d: 'M4 6H11M15 6H20' } },
    { tag: 'circle', attrs: { cx: 13, cy: 6, r: 2 } },
    { tag: 'path', attrs: { d: 'M4 12H6M10 12H20' } },
    { tag: 'circle', attrs: { cx: 8, cy: 12, r: 2 } },
    { tag: 'path', attrs: { d: 'M4 18H13M17 18H20' } },
    { tag: 'circle', attrs: { cx: 15, cy: 18, r: 2 } }
  ]),
  profile: currentLine([
    {
      tag: 'path',
      attrs: {
        d: 'M12.22 2H11.78A2 2 0 0 0 9.78 4V4.18A2 2 0 0 1 8.78 5.91L8.35 6.16A2 2 0 0 1 6.35 6.16L6.2 6.08A2 2 0 0 0 3.47 6.81L3.25 7.19A2 2 0 0 0 3.98 9.92L4.13 10.02A2 2 0 0 1 5.13 11.74V12.25A2 2 0 0 1 4.13 13.99L3.98 14.08A2 2 0 0 0 3.25 16.81L3.47 17.19A2 2 0 0 0 6.2 17.92L6.35 17.84A2 2 0 0 1 8.35 17.84L8.78 18.09A2 2 0 0 1 9.78 19.82V20A2 2 0 0 0 11.78 22H12.22A2 2 0 0 0 14.22 20V19.82A2 2 0 0 1 15.22 18.09L15.65 17.84A2 2 0 0 1 17.65 17.84L17.8 17.92A2 2 0 0 0 20.53 17.19L20.75 16.81A2 2 0 0 0 20.02 14.08L19.87 13.99A2 2 0 0 1 18.87 12.25V11.74A2 2 0 0 1 19.87 10L20.02 9.91A2 2 0 0 0 20.75 7.18L20.53 6.8A2 2 0 0 0 17.8 6.07L17.65 6.15A2 2 0 0 1 15.65 6.15L15.22 5.9A2 2 0 0 1 14.22 4.17V4A2 2 0 0 0 12.22 2Z'
      }
    },
    { tag: 'circle', attrs: { cx: 12, cy: 12, r: 3 } }
  ]),
  avatar: currentFill([
    { tag: 'circle', attrs: { cx: 12, cy: 7.75, r: 4.25 } },
    {
      tag: 'path',
      attrs: { d: 'M3.25 21C3.9 15.65 6.85 13 12 13C17.15 13 20.1 15.65 20.75 21H3.25Z' }
    }
  ]),
  admin: currentLine([
    { tag: 'path', attrs: { d: 'M12 3L19 6V11C19 15.5 16.2 19 12 21C7.8 19 5 15.5 5 11V6L12 3Z' } },
    { tag: 'circle', attrs: { cx: 12, cy: 10, r: 2 } },
    {
      tag: 'path',
      attrs: { d: 'M8.75 16C9.25 14.5 10.3 13.75 12 13.75C13.7 13.75 14.75 14.5 15.25 16' }
    }
  ]),
  return: currentLine([
    { tag: 'path', attrs: { d: 'M19 12H5' } },
    { tag: 'path', attrs: { d: 'M10 7L5 12L10 17' } }
  ]),
  home: currentLine([
    { tag: 'path', attrs: { d: 'M3.5 10.5L12 3.5L20.5 10.5' } },
    { tag: 'path', attrs: { d: 'M5.5 9.5V20H18.5V9.5' } },
    { tag: 'path', attrs: { d: 'M9.5 20V14H14.5V20' } }
  ]),
  language: currentLine([
    { tag: 'circle', attrs: { cx: 12, cy: 12, r: 9 } },
    { tag: 'path', attrs: { d: 'M3.5 9H20.5M3.5 15H20.5' } },
    {
      tag: 'path',
      attrs: {
        d: 'M12 3C14.5 5.5 15.5 8.5 15.5 12C15.5 15.5 14.5 18.5 12 21C9.5 18.5 8.5 15.5 8.5 12C8.5 8.5 9.5 5.5 12 3Z'
      }
    }
  ]),
  'chevron-right': currentLine([{ tag: 'path', attrs: { d: 'M9 6L15 12L9 18' } }]),
  'two-factor': currentLine([
    { tag: 'rect', attrs: { x: 3.5, y: 10, width: 12.5, height: 10.5, rx: 3 } },
    { tag: 'path', attrs: { d: 'M6.5 10V7.5C6.5 4.75 8.35 3 10 3C11.65 3 13.5 4.75 13.5 7.5V10' } },
    { tag: 'path', attrs: { d: 'M16.5 16.5L18.5 18.5L22 14.5' } }
  ]),
  'service-bot': currentLine([
    { tag: 'rect', attrs: { x: 3, y: 7, width: 18, height: 13, rx: 4 } },
    { tag: 'path', attrs: { d: 'M12 7V3M9.5 3H14.5' } },
    { tag: 'circle', attrs: { cx: 8.5, cy: 13, r: 1 } },
    { tag: 'circle', attrs: { cx: 15.5, cy: 13, r: 1 } },
    { tag: 'path', attrs: { d: 'M8.5 17H15.5' } }
  ]),
  calendar: currentLine([
    { tag: 'rect', attrs: { x: 3, y: 5, width: 18, height: 16, rx: 4 } },
    { tag: 'path', attrs: { d: 'M7 3V7M17 3V7M3 10H21' } },
    { tag: 'path', attrs: { d: 'M8 14H10M14 14H16M8 18H10' } }
  ]),
  devices: currentLine([
    { tag: 'rect', attrs: { x: 2.5, y: 4, width: 14, height: 11.5, rx: 2.5 } },
    { tag: 'path', attrs: { d: 'M5 20H14M8 15.5V20M17.5 8H21.5V20H16.5' } }
  ]),
  terms: currentLine([
    { tag: 'path', attrs: { d: 'M5 3H14L19 8V21H5V3Z' } },
    { tag: 'path', attrs: { d: 'M14 3V8H19M8.5 13L10.5 15L15 10.5M8.5 18H15.5' } }
  ]),
  referral: currentLine([
    { tag: 'circle', attrs: { cx: 6, cy: 12, r: 2.5 } },
    { tag: 'circle', attrs: { cx: 18, cy: 6, r: 2.5 } },
    { tag: 'circle', attrs: { cx: 18, cy: 18, r: 2.5 } },
    { tag: 'path', attrs: { d: 'M8.5 10.75L15.5 7.25M8.5 13.25L15.5 16.75' } }
  ]),
  api: currentLine([
    { tag: 'rect', attrs: { x: 3, y: 4, width: 18, height: 16, rx: 4 } },
    { tag: 'path', attrs: { d: 'M9 9L6 12L9 15M15 9L18 12L15 15M13.5 8L10.5 16' } }
  ]),
  logout: currentLine([
    {
      tag: 'path',
      attrs: {
        d: 'M14 8V6C14 4.35 12.65 3 11 3H6C4.35 3 3 4.35 3 6V18C3 19.65 4.35 21 6 21H11C12.65 21 14 19.65 14 18V16'
      }
    },
    { tag: 'path', attrs: { d: 'M10 12H21M17 8L21 12L17 16' } }
  ]),
  'status-success': currentLine([
    { tag: 'circle', attrs: { cx: 12, cy: 12, r: 9 } },
    { tag: 'path', attrs: { d: 'M7.5 12L10.75 15.25L17 8.75' } }
  ]),
  'status-info': currentLine([
    { tag: 'circle', attrs: { cx: 12, cy: 12, r: 9 } },
    { tag: 'path', attrs: { d: 'M12 10.5V16' } },
    { tag: 'circle', attrs: { cx: 12, cy: 7.5, r: 0.5, fill: 'currentColor' } }
  ]),
  'status-warning': currentLine([
    { tag: 'path', attrs: { d: 'M12 3L22 20H2L12 3Z' } },
    { tag: 'path', attrs: { d: 'M12 9V14' } },
    { tag: 'circle', attrs: { cx: 12, cy: 17, r: 0.5, fill: 'currentColor' } }
  ]),
  'status-danger': currentLine([
    { tag: 'circle', attrs: { cx: 12, cy: 12, r: 9 } },
    { tag: 'path', attrs: { d: 'M8.5 8.5L15.5 15.5M15.5 8.5L8.5 15.5' } }
  ]),
  'crypto-transfer': currentLine([
    {
      tag: 'path',
      attrs: { d: 'M4 6C4 4.35 7.35 3 11.5 3S19 4.35 19 6S15.65 9 11.5 9S4 7.65 4 6Z' }
    },
    {
      tag: 'path',
      attrs: { d: 'M4 6V15C4 16.45 6.55 17.65 10 17.95M4 10.5C4 11.95 6.55 13.15 10 13.45' }
    },
    { tag: 'circle', attrs: { cx: 17, cy: 17, r: 4 } },
    { tag: 'path', attrs: { d: 'M17 15V19M15 17H19' } }
  ]),
  'cash-transfer': currentLine([
    { tag: 'rect', attrs: { x: 3, y: 5, width: 18, height: 14, rx: 3 } },
    { tag: 'path', attrs: { d: 'M3 9H21M7 15H11M16 13L19 16M19 16V13M19 16H16' } }
  ]),
  'cta-arrow': currentLine([{ tag: 'path', attrs: { d: 'M4 12H20M14 6L20 12L14 18' } }]),
  check: currentLine([{ tag: 'path', attrs: { d: 'M4.5 12L9 16.5L19.5 6' } }]),
  'device-mobile': currentLine([
    { tag: 'rect', attrs: { x: 7, y: 2, width: 10, height: 20, rx: 3 } },
    { tag: 'path', attrs: { d: 'M10 5H14M11 19H13' } }
  ]),
  'device-laptop': currentLine([
    { tag: 'rect', attrs: { x: 3, y: 4, width: 18, height: 13, rx: 3 } },
    { tag: 'path', attrs: { d: 'M2 21H22M8 17L7 21M16 17L17 21' } }
  ]),
  copy: currentLine([
    { tag: 'rect', attrs: { x: 4, y: 3, width: 12, height: 14, rx: 3 } },
    {
      tag: 'path',
      attrs: {
        d: 'M18 7.5C19.2 8 20 9.15 20 10.5V18C20 19.65 18.65 21 17 21H11.5C10.15 21 9 20.2 8.5 19'
      }
    }
  ])
})
